"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ko = require("knockout");
var validation = require("knockout.validation");
var baseViewModel_1 = require("./baseViewModel");
var ajaxUtils_1 = require("../../../app/utils/ajaxUtils");
validation.init({
    insertMessages: true,
    decorateElement: true,
    decorateInputElement: true,
    messagesOnModified: false,
    errorElementClass: "has-error",
    errorMessageClass: "help-inline error"
}, true);
validation.localize({
    required: "Необходимо заполнить это поле.",
    min: "Значение должно быть больше или равно {0}.",
    max: "Значение должно быть меньше или равно {0}.",
    minLength: "Длина поля должна быть не меньше {0} символов.",
    maxLength: "Длина поля должна быть не больше {0} символов.",
    pattern: "Пожалуйста проверьте это поле.",
    step: "Значение поле должно изменяться с шагом {0}",
    email: "Введите в поле правильный адрес email",
    date: "Пожалуйста введите правильную дату",
    dateISO: "Пожалуйста введите правильную дату в формате ISO",
    number: "Поле должно содержать число",
    digit: "Поле должно содержать цифры",
    phoneUS: "Поле должно содержать правильный номер телефона",
    equal: "Значения должны быть равны",
    notEqual: "Пожалуйста выберите другое значение.",
    unique: "Значение должно быть уникальным."
});
var ValidatedViewModel = (function (_super) {
    __extends(ValidatedViewModel, _super);
    function ValidatedViewModel(options) {
        _super.call(this, options);
        this.processing = ko.observable(false);
        this.errorMessages = ko.observableArray();
    }
    ValidatedViewModel.prototype.initValidation = function () {
        this.validation = ko.validatedObservable(this);
    };
    ValidatedViewModel.prototype.submit = function (formElement, extendedData) {
        var _this = this;
        if (this.validation !== undefined && !this.validation.isValid()) {
            this.validation.errors.showAllMessages();
            return;
        }
        ;
        if (this.processing())
            return;
        this.beforeSubmit(formElement, extendedData, function () {
            ajaxUtils_1.AjaxUtils.submit(formElement, extendedData)
                .done(function (result) {
                if (!result.isSuccessful) {
                    _this.errorMessages(result.messages);
                    if (result.data && result.data.stackTrace !== undefined) {
                        console.error(result.data.stackTrace);
                    }
                }
                else {
                    if (result.messages && result.messages.length > 0) {
                        app.f7.addNotification({ message: result.messages[0], button: { text: "ОК", close: true }, hold: 3000 });
                    }
                    _this.onSubmitSucess(result, formElement);
                }
            })
                .fail(function () {
                alert("Произошла ошибка. Пожалуйста, повторите операцию еще раз или сообщите об этом в службу поддержки.");
            })
                .always(function () {
                setTimeout(function () {
                    _this.processing(false);
                }, 0);
            });
        });
    };
    ValidatedViewModel.prototype.beforeSubmit = function (formElement, extendedData, callback) {
        this.processing(true);
        this.errorMessages([]);
        callback();
    };
    ValidatedViewModel.prototype.onSubmitSucess = function (result, formElement) {
        // override this
    };
    return ValidatedViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ValidatedViewModel;
//# sourceMappingURL=validatedViewModel.js.map